import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (e) {
      console.warn("Unable to scroll to top:", e);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="w-full px-8 lg:px-16">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src="https://static.readdy.ai/image/fe226e3a566555ddeb1e5a20b9b4643c/5ff4ff3d5009244f40339f86dca03486.jpeg"
                alt="FluxPoint Digital LLC"
                className="h-12 w-auto"
              />
            </Link>
            <Link
              to="/"
              className="text-sm font-medium text-gray-700 hover:text-[#1A2B4A] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line mr-1"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </nav>

      <main className="pt-32 pb-24 px-8 lg:px-16">
        <article className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-[#1A2B4A] mb-2">
            Terms of Service
          </h1>
          <p className="text-sm text-gray-500 mb-10">
            Effective Date: January 1, 2025
          </p>

          <div className="space-y-8 text-[15px] leading-relaxed text-gray-700">
            <p>Welcome to FluxPoint Digital LLC.</p>
            <p>By accessing this website, you agree to the following terms.</p>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#use-of-website" id="use-of-website">
                  1. Use of Website
                </a>
              </h4>
              <p>
                This website is provided for informational and business
                purposes. You agree to use the website lawfully and not for any
                unauthorized or harmful activities.
              </p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#intellectual-property" id="intellectual-property">
                  2. Intellectual Property
                </a>
              </h4>
              <p className="mb-3">
                All content on this website, including text, graphics, branding,
                and design, is the property of FluxPoint Digital LLC unless
                otherwise stated.
              </p>
              <p>You may not copy, reproduce, or distribute content without written permission.</p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#no-investment-advice" id="no-investment-advice">
                  3. No Investment Advice
                </a>
              </h4>
              <p className="mb-3">
                Information provided on this website does not constitute
                financial, investment, legal, or tax advice.
              </p>
              <p>All investment decisions should be made independently and at your own risk.</p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#limitation-of-liability" id="limitation-of-liability">
                  4. Limitation of Liability
                </a>
              </h4>
              <p>
                FluxPoint Digital LLC shall not be liable for any indirect,
                incidental, or consequential damages arising from use of this
                website.
              </p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#third-party-links" id="third-party-links">
                  5. Third-Party Links
                </a>
              </h4>
              <p>
                Our website may contain links to third‑party websites. We are
                not responsible for their content or policies.
              </p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#modifications" id="modifications">
                  6. Modifications
                </a>
              </h4>
              <p>We reserve the right to update or modify these Terms at any time.</p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#governing-law" id="governing-law">
                  7. Governing Law
                </a>
              </h4>
              <p>
                These Terms are governed by the laws of the State of California,
                United States.
              </p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-[#1A2B4A] mb-3">
                <a href="#contact-information" id="contact-information">
                  8. Contact Information
                </a>
              </h4>
              <p>FluxPoint Digital LLC</p>
              <p>
                <a
                  href="mailto:admin@fluxpointdigital.org"
                  className="text-[#1A2B4A] font-medium underline hover:text-[#2a3f66] cursor-pointer"
                >
                  admin@fluxpointdigital.org
                </a>
              </p>
            </section>
          </div>
        </article>
      </main>

      <footer className="bg-[#2C2C2C] text-white">
        <div className="border-t border-gray-700">
          <div className="max-w-7xl mx-auto px-8 lg:px-16 py-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-center md:text-left">
                <p className="text-xs text-gray-500">
                  © 2026 FluxPoint Digital LLC. All rights reserved.
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Registered in California, USA.
                </p>
              </div>
              <div className="flex space-x-6">
                <Link
                  to="/"
                  className="text-xs text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </Link>
                <Link
                  to="/privacy-policy"
                  className="text-xs text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Privacy Policy
                </Link>
                <a
                  href="https://readdy.ai/?ref=logo"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-xs text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
